// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAgvwRbg09fQSSuwyPEKafAza2wUBwitd0",
    authDomain: "my-portfolio-3b3f3.firebaseapp.com",
    projectId: "my-portfolio-3b3f3",
    storageBucket: "my-portfolio-3b3f3.appspot.com",
    messagingSenderId: "119468875488",
    appId: "1:119468875488:web:b729957bf2723973d37a85"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db= getFirestore(app);